<template>
  <v-radio-group v-model="valueMediator" mandatory>
    <slot />
    <v-list :color="color" :dark="dark" >
      <v-list-item v-for="(point, index) in pointsData" :key="index">
        <v-list-item-content>
          <v-list-item-title>
            <v-radio :value="index" :label="point.signboard || point.name" />
          </v-list-item-title>
          <v-list-item-subtitle v-if="point.address">
            {{ point.address }}
          </v-list-item-subtitle>
          <v-list-item-subtitle v-if="point.pickup_time_from && point.pickup_time_to">
            {{ $dictionary.get('pickup-time') }}:
            {{ $tools.time.range(point.pickup_time_from, point.pickup_time_to) }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-radio-group>
</template>

<script>
export default {
  name: 'PointSelect',
  props: {
    value: { type: [Number, String], default: 0 },
    points: { type: Array, default: null }
  },
  computed: {
    pointsData() {
      const { points } = this.$store.state.data;
      if (!this.points) return points;
      return points.filter(({ _id }) => this.points.includes(_id));
    },
    valueMediator: {
      get() { return this.value; },
      set(value) { this.$emit('input', value); },
    },
    dark() { return this.$store.state.theme.mainDark; },
    color() { return this.$store.state.theme.mainColor; },
  }
};
</script>
